import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountLoans,
  getAccountLoan,
  createAccountLoan,
  updateAccountLoan,
  deleteAccountLoan,
  getAccountLoanBalance,
  getAccountLoanSummary,
} from "api/accountLoanApi"
import { useQuery } from "@tanstack/react-query"

export const ACCOUNT_LOAN_QUERY_KEY = "account-loans"

export const useAccountLoans = (params = {}, enabled = true) => {
  return usePaginatedResource(ACCOUNT_LOAN_QUERY_KEY, getAccountLoans, params, enabled)
}

export const useAccountLoan = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_LOAN_QUERY_KEY, getAccountLoan, id, enabled)
}

export const useCreateAccountLoan = () => {
  return useCreateResource(createAccountLoan, ACCOUNT_LOAN_QUERY_KEY)
}

export const useEditAccountLoan = () => {
  return useEditResource(updateAccountLoan, ACCOUNT_LOAN_QUERY_KEY)
}

export const useDeleteAccountLoan = () => {
  return useDeleteResource(deleteAccountLoan, ACCOUNT_LOAN_QUERY_KEY)
}

export const useAccountLoanBalance = (id, enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_LOAN_QUERY_KEY, "balance", id],
    queryFn: () => getAccountLoanBalance(id),
    enabled: enabled && !!id,
  })
}

export const useAccountLoanSummary = (borrowerType, borrowerId, enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_LOAN_QUERY_KEY, "summary", borrowerType, borrowerId],
    queryFn: () => getAccountLoanSummary(borrowerType, borrowerId),
    enabled: enabled && !!borrowerType && !!borrowerId,
  })
}
